import { render, staticRenderFns } from "./PointItem.vue?vue&type=template&id=dc64b708&scoped=true&"
import script from "./PointItem.vue?vue&type=script&lang=js&"
export * from "./PointItem.vue?vue&type=script&lang=js&"
import style0 from "./PointItem.vue?vue&type=style&index=0&id=dc64b708&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc64b708",
  null
  
)

export default component.exports